/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Quima_backend
 * OpenAPI spec version: v1
 */
import axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AddMemberRequestDto,
  UpdateOrganizationRequestDto
} from '../generated.schemas';




  export const getOrg = (axiosInstance: AxiosInstance = axios) => {
/**
 * @summary Edit organization details.
 */
const putApiOrgOrganizationIdEdit = (
    organizationId: number,
    updateOrganizationRequestDto: UpdateOrganizationRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(
      `/api/Org/${organizationId}/edit`,
      updateOrganizationRequestDto,options
    );
  }
/**
 * @summary Get organization details by ID.
 */
const getOrganizationById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Org/${id}`,options
    );
  }
/**
 * @summary Delete an organization.
 */
const deleteApiOrgOrganizationIdDelete = (
    organizationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/Org/${organizationId}/delete`,options
    );
  }
/**
 * @summary Invite a member to the organization by email.
 */
const postApiOrgOrganizationIdMembersInvite = (
    organizationId: number,
    addMemberRequestDto: AddMemberRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Org/${organizationId}/members/invite`,
      addMemberRequestDto,options
    );
  }
/**
 * @summary Remove a member from the organization.
 */
const deleteApiOrgOrganizationIdMembersRemoveMemberId = (
    organizationId: number,
    memberId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(
      `/api/Org/${organizationId}/members/remove/${memberId}`,options
    );
  }
/**
 * @summary Get all members of an organization.
 */
const getApiOrgOrganizationIdMembers = (
    organizationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(
      `/api/Org/${organizationId}/members`,options
    );
  }
/**
 * @summary Accept an invitation to join an organization.
 */
const postApiOrgOrganizationIdAcceptInvite = (
    organizationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(
      `/api/Org/${organizationId}/accept-invite`,undefined,options
    );
  }
return {putApiOrgOrganizationIdEdit,getOrganizationById,deleteApiOrgOrganizationIdDelete,postApiOrgOrganizationIdMembersInvite,deleteApiOrgOrganizationIdMembersRemoveMemberId,getApiOrgOrganizationIdMembers,postApiOrgOrganizationIdAcceptInvite}};
export type PutApiOrgOrganizationIdEditResult = AxiosResponse<void>
export type GetOrganizationByIdResult = AxiosResponse<void>
export type DeleteApiOrgOrganizationIdDeleteResult = AxiosResponse<void>
export type PostApiOrgOrganizationIdMembersInviteResult = AxiosResponse<void>
export type DeleteApiOrgOrganizationIdMembersRemoveMemberIdResult = AxiosResponse<void>
export type GetApiOrgOrganizationIdMembersResult = AxiosResponse<void>
export type PostApiOrgOrganizationIdAcceptInviteResult = AxiosResponse<void>
